export default "__VITE_ASSET__099b8350__"